import formAction from '../actions/formActions';
import Step2 from '../stores/Step2';
import Step3 from '../stores/Step3';
let initialStateForm = [];
prepareInitialState(Step2, initialStateForm);
prepareInitialState(Step3, initialStateForm);
function cards(state = initialStateForm, formAction) {
    switch (formAction.type) {
        case 'ADD_FORM':
            var newState = [...state];
            newState.push(formAction.data);
            return newState;

        case 'REMOVE_FORM':
            var removeState = [...state];
            for (var i = 0; i < removeState.length; i++) {
                if(removeState[i].id === formAction.id) {
                    removeState.splice(i, 1);
                    break;
                }
            }
            return removeState;

        case 'UPDATE_FORM':
            var updateState = [...state];
            for (var z = 0; z < updateState.length; z++) {
                if(updateState[z].id === formAction.data.id) {
                    updateState[z] = formAction.data;
                    break;
                }
            }
            return updateState;

        default:
            return state
    }
}

function prepareInitialState(formStep, initState) {
    for (var i = 0; i < formStep.length; i++) {
        let stepValue = {};
        stepValue.id = formStep[i]['id'];
        stepValue.label = formStep[i]['label'];
        stepValue.value = '';
        initState.push(stepValue);
    }
}

export default cards;



/** WEBPACK FOOTER **
 ** ./src/reducers/Form.js
 **/